module.exports = __webpack_public_path__ + "img/es_flag.94782893.png";